import React, { useCallback, useMemo } from 'react';
import { StyleSheet, View } from 'react-native';
import { useAnimatedScrollHandler } from 'react-native-reanimated';
import { useAppSelector } from 'store/hooks';
import { rem } from 'design-system';
import EmojiText from 'design-system/EmojiText';
import { ModalFlashList } from 'design-system/ModalScrollables';
import Text from 'design-system/Text';
import { useBottomOffset } from 'hooks/useBottomOffset';
import { useMarginBottom } from 'hooks/useMarginBottom';
import { useScrollableModalMaxHeight } from 'hooks/useScrollableModalMaxHeight';
import TransferAccountRow from 'features/transfers/components/TransferAccountRow';
import Modal from 'utils/packages/Modal';
import { selectTransferPotsFromPotType } from '../reducers/selectors';
const estimatedItemSize = rem(98);
const keyExtractor = (item) => item.id;
const AddMoneyPotPickerModalContent = ({ from, current, onSelect, sharedValue }) => {
    const fromPot = from.type === 'pot' ? from.pot : undefined;
    const potsOfTheSameType = useAppSelector((state) => selectTransferPotsFromPotType(state, fromPot?.type, fromPot?.productId));
    const pots = useMemo(() => potsOfTheSameType.filter((siblingPot) => (fromPot ? siblingPot.id !== fromPot.id : true)), [fromPot, potsOfTheSameType]);
    const bottom = useBottomOffset();
    const contentContainerStyle = useMarginBottom('paddingBottom');
    const scrollHandler = useAnimatedScrollHandler((handle) => {
        // eslint-disable-next-line no-param-reassign
        sharedValue.value = handle.contentOffset.y;
    }, []);
    const handleItemPress = useCallback((item) => () => {
        onSelect(item);
        Modal.hide();
    }, [onSelect]);
    const renderItem = useCallback(({ item }) => (<TransferAccountRow name={item.name} amount={item.balance} desc={<Text TextThin-14 Secondary>
            {item.productName ? `${item.productName}\n` : ''}
            {item.interestRate ? (<Text TextThin-14 Secondary>
                <Text NumbersThin-14 Secondary>
                  {item.interestRate}%
                </Text>{' '}
                AER
              </Text>) : undefined}
          </Text>} onPress={handleItemPress(item)} selected={current?.id === item.id} Icon={<EmojiText>{item.emoji}</EmojiText>}/>), [current?.id, handleItemPress]);
    const maxHeight = useScrollableModalMaxHeight();
    const listHeight = useMemo(() => Math.min(maxHeight, pots.length * estimatedItemSize + bottom), [bottom, maxHeight, pots.length]);
    const style = useMemo(() => ({ height: listHeight }), [listHeight]);
    return (<View style={style}>
      <ModalFlashList data={pots} renderItem={renderItem} scrollEventThrottle={16} onScroll={scrollHandler} keyExtractor={keyExtractor} keyboardShouldPersistTaps="handled" contentContainerStyle={contentContainerStyle}/>
    </View>);
};
export const AddMoneyPotPickerModal = {
    show: (from, current, onSelect, sharedValue, onDidHideCallback) => {
        Modal.show(<AddMoneyPotPickerModalContent from={from} current={current} onSelect={onSelect} sharedValue={sharedValue}/>, {
            containerStyle: styles.modal,
            title: 'Select a pot',
            scrollable: {
                scrollValue: sharedValue,
            },
            onDidHideCallback,
        });
    },
    hide: () => {
        Modal.hide();
    },
};
const styles = StyleSheet.create({
    modal: {
        paddingHorizontal: 0,
        overflow: 'hidden',
    },
});
